/**
 * Canal "uma rota do produto respondeu que ele está travado".
 *
 * O direito de uso é revalidado de tempos em tempos, mas pode ser
 * revogado entre uma verificação e outra (o admin bloqueou, a compra
 * venceu). Quando a API de um produto recebe `<codigo>.inativo`, ela avisa
 * aqui; quem controla a tela (o gate do produto) revalida na hora e troca
 * o conteúdo pela tela de bloqueio — em vez de o operador ficar vendo um
 * erro técnico atrás do outro.
 */

type Ouvinte = () => void;

const ouvintes = new Map<string, Set<Ouvinte>>();

export function avisarProdutoBloqueado(codigo: string): void {
  ouvintes.get(codigo)?.forEach((ouvinte) => ouvinte());
}

export function aoProdutoBloqueado(codigo: string, ouvinte: Ouvinte): () => void {
  let doCodigo = ouvintes.get(codigo);
  if (!doCodigo) {
    doCodigo = new Set();
    ouvintes.set(codigo, doCodigo);
  }
  doCodigo.add(ouvinte);
  return () => {
    doCodigo.delete(ouvinte);
  };
}
